//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SessionTypeIcon from './SessionTypeIcon.vue';
import { formatTime } from './scheduleTimeUtils.js';
import { formatDayLabel, isNonSessionItem as checkNonSessionItem } from './scheduleResultGrouping.js';
import { summaryHtml } from './sanitizeHtml.js';

export default {
  name: 'ScheduleSessionCard',

  components: {
    SessionTypeIcon,
  },

  props: {
    result: {
      type: Object,
      required: true,
    },
    /** 'expanded' | 'compact' | 'simple' — set by parent based on card mode logic */
    mode: {
      type: String,
      default: 'expanded',
      validator: v => ['expanded', 'compact', 'simple'].includes(v),
    },
    showDate: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    sanitizedSummary() {
      return summaryHtml(this.result.summary);
    },

    sessionType() {
      return (this.result.meta && this.result.meta.sessionType) || '';
    },

    isNonSessionItem() {
      return checkNonSessionItem(this.sessionType);
    },

    creditType() {
      const value = (this.result.meta && this.result.meta.sessionCreditType) || '';
      if (!value || value === 'Not for Credit') return '';
      return value;
    },

    sponsorName() {
      return (this.result.meta && this.result.meta.sponsorName) || '';
    },

    preregRequired() {
      const value = this.result.meta && this.result.meta.preregRequired;
      if (value === undefined || value === null || value === false) return false;
      // Treat anything else truthy as required, except the string 'false' / number 0.
      if (value === 'false' || value === 0 || value === '0') return false;
      return Boolean(value);
    },

    sessionTopics() {
      return (this.result.meta && Array.isArray(this.result.meta.sessionTopics)) ? this.result.meta.sessionTopics : [];
    },

    speakers() {
      if (!this.result.meta || !this.result.meta.speakers) return [];
      return Array.isArray(this.result.meta.speakers) ? this.result.meta.speakers : [];
    },

    speakerDisplay() {
      const count = this.speakers.length;
      if (count === 0) return 'Speaker TBA';
      if (count === 1) return this.speakers[0].name;
      if (count === 2) return `${this.speakers[0].name}, ${this.speakers[1].name}`;
      if (count === 3) return `${this.speakers[0].name}, ${this.speakers[1].name} +1`;
      return 'Multiple Speakers';
    },

    speakerSubtitle() {
      const count = this.speakers.length;
      if (count === 0) return '';
      if (count === 1) return this.formatSpeakerDetail(this.speakers[0]);
      if (count === 2) {
        const bothHaveData = this.speakers.every(s => s.jobTitle || s.organization);
        if (bothHaveData) {
          return `${this.formatSpeakerDetail(this.speakers[0])} • ${this.formatSpeakerDetail(this.speakers[1])}`;
        }
        return 'Multiple Roles, Organizations';
      }
      if (count === 3) return 'Multiple Roles, Organizations';
      // 4+ speakers: show shared org if all speakers have identical non-empty org
      const orgs = this.speakers.map(s => s.organization);
      const uniqueOrgs = [...new Set(orgs.filter(Boolean))];
      if (uniqueOrgs.length === 1 && orgs.every(o => o)) return uniqueOrgs[0];
      return 'Multiple Roles, Organizations';
    },

    visibleSpeakers() {
      return this.speakers.slice(0, 3);
    },

    overflowCount() {
      return Math.max(0, this.speakers.length - 3);
    },

    location() {
      return (this.result.meta && this.result.meta.sessionRoom) || '';
    },

    externalId() {
      return (this.result.meta && this.result.meta.externalId) || null;
    },

    dynamicSubpageSlug() {
      return (this.result.meta && this.result.meta.dynamicSubpageSlug) || null;
    },

    timeDisplay() {
      const start = this.formatTime(this.result.meta && this.result.meta.startDate);
      const end = this.formatTime(this.result.meta && this.result.meta.endDate);
      if (start && end) return `${start}-${end}`;
      return start || '';
    },

    dateDisplay() {
      const startDate = this.result.meta && this.result.meta.startDate;
      if (!startDate) return '';
      return formatDayLabel(startDate.slice(0, 10));
    },

  },

  methods: {
    onAddClick(e) {
      this.$emit('add-session', { result: this.result, triggerEl: e.currentTarget });
    },

    navigateToDetail() {
      if (!this.externalId) return;
      const detailUrl = `${this.$root.parentPageUrl}/sessions/${this.dynamicSubpageSlug}`;
      history.pushState({ swapcardSessionId: this.externalId, fromListing: true }, '', detailUrl);
      this.$emit('navigate-detail', { swapcardSessionId: this.externalId });
    },

    formatTime,

    initials(name) {
      const parts = (name || '').split(' ').filter(Boolean);
      if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      return parts[0] ? parts[0][0].toUpperCase() : '';
    },

    avatarColor(index) {
      const colors = ['#2563EB', '#0F766E', '#10B981', '#036EBA'];
      return colors[index % colors.length];
    },

    formatSpeakerDetail(speaker) {
      return [speaker.jobTitle, speaker.organization].filter(Boolean).join(', ');
    },
  },
};
